import apiClient from "./apiClient";

export const fetchNotifications = (page = 1) =>
  apiClient.get("/notifications", { params: { page } }).then(({ data }) => data);

export const fetchUnreadCount = () =>
  apiClient.get("/notifications/unread-count").then(({ data }) => data.unread_count ?? 0);

export const markNotificationRead = (id) =>
  apiClient.post(`/notifications/${id}/read`).then(({ data }) => data);

export const markAllNotificationsRead = () =>
  apiClient.post("/notifications/read-all").then(({ data }) => data);

export const deleteNotification = (id) =>
  apiClient.delete(`/notifications/${id}`).then(({ data }) => data);
